export default {
  queryCourierRecruit: '/courier/api/v2/recruits/queryCourierRecruit'
}
